import script from "./HelperText.vue?vue&type=script&setup=true&lang=js"
export * from "./HelperText.vue?vue&type=script&setup=true&lang=js"

import "./HelperText.vue?vue&type=style&index=0&id=229545ab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229545ab"]])

export default __exports__